import { render, staticRenderFns } from "./AuthorEdit.vue?vue&type=template&id=262ce0cb&"
import script from "./AuthorEdit.vue?vue&type=script&lang=js&"
export * from "./AuthorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports